import { Link } from "react-router-dom";
import TranslateWidget from "./TranslateWidget";

// Shared mobile app bar: centered Cars53 logo, optional back button (left)
// and an optional right-side slot (avatar, action, etc.).
const MobileHeader = ({ back, right }) => (
    <div className="mlux-appbar" data-rise="1">
        {back && (
            <Link to={typeof back === "string" ? back : "/"} className="mlux-back-btn" aria-label="Back">
                <i className="fas fa-arrow-left"></i>
            </Link>
        )}
        <Link to="/" className="mlux-applogo-link">
            <img src="/assets/img/logo/partner-logo.png" alt="Cars53 Partner" className="mlux-applogo" />
        </Link>
        <div className="mlux-appbar-right">
            <TranslateWidget />
            {right}
        </div>
    </div>
);

export default MobileHeader;
